module.exports = __webpack_public_path__ + "img/ИФ-1(А)-044.da9b4137.png";